import { Location } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { ISideNavigationConfig } from '@shared/modules/side-navigation/interfaces/side-navigation-config.interface';
import { SideNavigationTabType } from '@shared/modules/side-navigation/enums/side-navigation-tab-type.enum';
import { ISideNavigationTab } from '@shared/modules/side-navigation/interfaces/side-navigation-tab.interface';
import { StorageService } from '@core/services/storage.service';
import { Subject, Subscription } from 'rxjs';

@Component({
  selector: 'side-navigation-base-menu',
  templateUrl: './side-navigation-base-menu.component.html',
  styleUrls: ['./side-navigation-base-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SideNavigationBaseMenuComponent implements OnInit, OnDestroy {
  SideNavigationTabType = SideNavigationTabType;
  hidden: boolean = false;
  activeTab: any = null;

  private urlChanged = new Subject();
  private sub: Subscription = new Subscription();

  @Input() config: ISideNavigationConfig;
  @Input() updateLocationParam: boolean = false;
  @Output('onTabClick') onTabClick: EventEmitter<ISideNavigationTab> = new EventEmitter<ISideNavigationTab>();
  @Output('onBackClick') onBackClick: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output('onHidden') onHidden: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    public changes: ChangeDetectorRef,
    private store: StorageService,
    private location: Location
  ) {}

  ngOnInit(): void {
    this.initHiddenSideNavigation();
    this.updateTabOnParamChange();
  }

  updateTabOnParamChange() {
    this.location.onUrlChange((url) => this.urlChanged.next(url));
    const sub = this.urlChanged.subscribe((url) => this.urlChange(url));
    this.sub.add(sub);
  }

  urlChange(url) {
    if (!this.updateLocationParam) return;
    const urlParams = new URLSearchParams(url);
    const param = urlParams.get('filters[a.stage][in]');
    const filtered = this.config.tabs.filter((i) => i.prop === param)[0];
    param && filtered ? this.activateTab(filtered) : null;
  }

  initHiddenSideNavigation() {
    const hiddenFromStore = this.store.HiddenSideNavigation;
    if (hiddenFromStore && hiddenFromStore[this.config.name]) {
      this.hide();
    }
  }

  setHiddenSideNavigationToStore() {
    const hiddenFromStore = this.store.HiddenSideNavigation || {};
    hiddenFromStore[this.config.name] = this.hidden;
    this.store.HiddenSideNavigation = hiddenFromStore;
  }

  toggleHidden() {
    this.hidden ? this.show() : this.hide();
  }

  hide() {
    this.hidden = true;
    this.onHidden.emit(true);
    this.setHiddenSideNavigationToStore();
    this.changes.detectChanges();
  }

  show() {
    this.hidden = false;
    this.onHidden.emit(false);
    this.setHiddenSideNavigationToStore();
    this.changes.detectChanges();
  }

  identify(index, item: ISideNavigationTab) {
    return item.name;
  }

  activateTab(tab) {
    if (!tab || this.activeTab?.prop === tab?.prop) return;
    this.activeTab = tab;
    this.config?.tabs?.forEach((i) => (i.active = false));
    tab.active = true;
    this.onTabClick.emit(tab);
    this.changes?.detectChanges();
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
